import { Datagrid, Filter, List, ReferenceField, ReferenceInput, SearchInput, SelectInput, TextField, usePermissions } from 'react-admin';
import { Permission, RecoveryUserExpand } from '../../components';
import ListPagination from '../../components/ListPagination';
import { PERMISSIONS } from '../../constants';
import { EmployeeType } from '../../models';

const DeletedAttedantUsersDatagrid = props => {
  const { permissions } = usePermissions();

  return (
    <Datagrid {...props} bulkActionButtons={false} rowClick="" expand={<RecoveryUserExpand />}>
      {permissions && permissions.includes(PERMISSIONS.ADMIN) &&
        <ReferenceField source="chainId" reference="chains" label="Rede">
          <TextField source="name" />
        </ReferenceField>}
      <TextField source="name" label="Nome" />
      <TextField source="login" label="Login" />
      {permissions && permissions.includes(PERMISSIONS.ADMIN) &&
        <ReferenceField
          source="profileId"
          reference="profiles"
          emptyText="Não definido"
          label="Perfil"
        >
          <TextField source="name" />
        </ReferenceField>}
    </Datagrid>
  );
};

const ListFilters = (props) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <Permission permission={PERMISSIONS.ADMIN} alwaysOn>
      <ReferenceInput
        source="chainId"
        reference="chains"
        sort={{ field: 'name', order: 'ASC' }}
        perPage={null}
      >
        <SelectInput optionText="name" label="Rede" emptyText="Todas" />
      </ReferenceInput>
    </Permission>
  </Filter>
);

const AttendantDeletedUserList = props => (
  <List
    {...props}
    basePath="attendant-employees/recovery"
    resource="employees/recovery"
    title="Usuários frentistas deletados"
    pagination={<ListPagination />}
    filter={{ type: EmployeeType.attendant }}
    filters={<ListFilters />}
    perPage={25}
    exporter={false}
    actions={false}
  >
    <DeletedAttedantUsersDatagrid />
  </List>
);

export default AttendantDeletedUserList;
